import React from 'react'
import { NavLink } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

export default function Nav() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('deptId'); 
    localStorage.removeItem('data');
    navigate(`/`);

  };

  const handleHome = () => {
    navigate(`/home`);
    window.location.reload();

  };
  return (
    <nav>

    <div className='nav'>
        <div>
        <h1 onClick={handleHome}>Logo</h1>
        </div>
        <div>
            <ul>
                <li><NavLink to='/home'>Bosh sahifa</NavLink></li>
                <li><NavLink to='/create'>Bo'lim yaratish</NavLink></li>
            </ul>
        </div>
        <div>
        <button onClick={handleLogout} className='logout23'>Chiqish</button>
            
        </div>
    </div>
    </nav>
  )
}
